"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var shared_1 = require("@formily/shared");
var react_2 = require("@formily/react");
var schema_1 = require("./schema");
var createEnum = function (enums) {
    if (shared_1.isArr(enums)) {
        return enums.map(function (item) {
            if (typeof item === 'object') {
                return item;
            }
            else {
                return {
                    label: item,
                    value: item
                };
            }
        });
    }
    return [];
};
var bindEffects = function (props, fieldProps, effect, notify) {
    shared_1.each(effect(function (type, payload) {
        return notify(type, { payload: payload, name: fieldProps.name, path: fieldProps.path });
    }, __assign({}, props)), function (event, key) {
        var prevEvent = key === 'onChange' ? props[key] : undefined;
        props[key] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (shared_1.isFn(event)) {
                event.apply(void 0, args);
            }
            if (shared_1.isFn(prevEvent)) {
                return prevEvent.apply(void 0, args);
            }
        };
    });
    return props;
};
exports.connect = function (options) {
    options = shared_1.defaults({
        valueName: 'value',
        eventName: 'onChange'
    }, options);
    return function (Component) {
        var ConnectedComponent = (function (fieldProps) {
            var _a;
            var value = fieldProps.value, name = fieldProps.name, mutators = fieldProps.mutators, form = fieldProps.form, editable = fieldProps.editable, props = fieldProps.props;
            var schema = new schema_1.Schema(props);
            var schemaComponentProps = schema.getExtendsComponentProps();
            var componentProps = __assign(__assign(__assign({}, options.defaultProps), schemaComponentProps), (_a = {}, _a[options.valueName] = value, _a[options.eventName] = function (event) {
                var _a;
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                mutators.change.apply(mutators, __spreadArrays([options.getValueFromEvent
                        ? (_a = options.getValueFromEvent).call.apply(_a, __spreadArrays([{
                                props: componentProps,
                                schema: schema,
                                field: fieldProps
                            },
                            event], args)) : event], args));
                if (shared_1.isFn(schemaComponentProps[options.eventName])) {
                    schemaComponentProps[options.eventName].apply(schemaComponentProps, __spreadArrays([event], args));
                }
            }, _a.onBlur = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                mutators.blur();
                if (shared_1.isFn(schemaComponentProps['onBlur'])) {
                    schemaComponentProps['onBlur'].apply(schemaComponentProps, args);
                }
            }, _a.onFocus = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                mutators.focus();
                if (shared_1.isFn(schemaComponentProps['onFocus'])) {
                    schemaComponentProps['onFocus'].apply(schemaComponentProps, args);
                }
            }, _a));
            if (shared_1.isValid(editable)) {
                if (shared_1.isFn(editable)) {
                    if (!editable(name)) {
                        componentProps.disabled = true;
                        componentProps.readOnly = true;
                    }
                }
                else if (editable === false) {
                    componentProps.disabled = true;
                    componentProps.readOnly = true;
                }
            }
            var extendsEffect = schema.getExtendsEffect();
            if (shared_1.isFn(extendsEffect)) {
                componentProps = bindEffects(componentProps, fieldProps, extendsEffect, form.notify);
            }
            if (shared_1.isFn(options.getProps)) {
                var newProps = options.getProps(componentProps, fieldProps);
                if (shared_1.isValid(newProps)) {
                    componentProps = newProps;
                }
            }
            if (shared_1.isArr(props.enum) && !componentProps.dataSource) {
                componentProps.dataSource = createEnum(props.enum);
            }
            else if (componentProps.dataSource) {
                componentProps.dataSource = createEnum(componentProps.dataSource);
            }
            if (shared_1.isValid(componentProps.editable)) {
                delete componentProps.editable;
            }
            var megaProps = schema.getMegaLayoutProps();
            var _b = react_2.useLayout(megaProps), full = _b.full, size = _b.size;
            if (full) {
                componentProps.style = __assign(__assign({}, (componentProps.style || {})), { width: '100%', flex: 1 });
            }
            if (size) {
                componentProps.size = size;
            }
            return react_1.default.createElement(shared_1.isFn(options.getComponent)
                ? options.getComponent(Component, props, fieldProps)
                : Component, componentProps);
        });
        Object.assign(ConnectedComponent, {
            __ALREADY_CONNECTED__: true
        });
        return ConnectedComponent;
    };
};
